module.exports = __webpack_public_path__ + "static/media/hbt_closets.48280d73.png";